import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StreamData } from 'types/streamData'
import DomainIcon from './DomainIcon'
import { StyledDomainLink } from '../index.css'

type LinkedDomainIconProps = {
  streamData: StreamData
}

const LinkedDomainIcon = ({ streamData }: LinkedDomainIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const { domain } = streamData

  return (
    <Tooltip mode={theme} enabled content={!domain ? t('soundbiteNoUrl') : domain}>
      <StyledDomainLink
        href={!domain ? undefined : `https://${domain}`}
        target="_blank"
        rel="noreferrer"
        disabled={!domain}
        onClick={(event) => {
          event.stopPropagation()
        }}>
        <DomainIcon streamData={streamData} />
      </StyledDomainLink>
    </Tooltip>
  )
}

export default LinkedDomainIcon
